import { useRouter } from "next/router";
import { call } from "goi_common";
import { GOI_PHONE } from "@/constants/contact";
import { useParlorInquiryModal as useSharedParlorInquiryModal } from "goi_common/src/design-system";

import type { ClickEventType } from "goi_common";

/**
 * parlor 용 장례식장 문의 모달.
 *
 * 조문 문의만 장례식장 직통으로 가고 나머지 셋은 고이 1666-9784 다.
 * 발신은 call() 로 통일한다. 이 앱의 장례식장 표면은 대부분 raw tel: 이라
 * 지금까지 goi_call 집계와 새벽 2~7시 차단에서 빠져 있었다.
 *
 * 번호는 장례식장 목록에서 찾아야 해서 클릭 시점에 동적으로 불러온다.
 * 대상 라우트가 전부 [id] 숫자라 router.query.id 로 찾는다.
 * 불러오기가 실패해도 모달은 열리고, 조문 문의는 고이로 폴백한다.
 */
export const useParlorInquiryModal = (eventPath: ClickEventType["path"]) => {
  const router = useRouter();
  const { openInquiryModal } = useSharedParlorInquiryModal({
    eventPath,
    onDial: (phoneNumber) => call(phoneNumber),
  });

  const openParlorInquiryModal = async () => {
    /**
     * /quote 는 장례식장이 정해지지 않은 공용 LP 인데 /place/[id]/quote 와 컨테이너를
     * 공유한다. 조문 문의가 걸 번호가 없으므로 모달을 띄우지 않고 바로 고이로 건다.
     */
    if (typeof router.query.id !== "string") {
      call(GOI_PHONE);
      return;
    }

    let facilityPhone: string | null = null;

    try {
      const { getParlorPhoneByRouteId } = await import("@/utils/parlorPhone");
      facilityPhone = getParlorPhoneByRouteId(router.query.id);
    } catch {
      facilityPhone = null;
    }

    openInquiryModal(facilityPhone);
  };

  return { openParlorInquiryModal };
};
